export default __webpack_public_path__ + "static/media/Disclaimer.ecce6e4b.svg";